import React from 'react';

import PageHeader from '../components/PageHeader';
import SectionHeading from '../components/SectionHeading';
import ImageSlider from '../components/ImageSlider';
import Button from '../components/Button';
import WaitingListForm from '../components/WaitingListForm';

const WaitingList = () => {
    return (
        <>
            {/* page header - start */}
            <PageHeader
            />
            {/* page header - end */}

            {/* contact form section - start */}
            <div className="contact-form-section">
                <div className="contact-form-section-wrapper" style={{paddingTop: "0px"}}>
                    <div className="container">
                        <div className="row gx-5 contact-form-section-row">
                            <div className="col-10 offset-1">
                                {/* contact form - start */}
                                <WaitingListForm/>
                                {/* contact form - end */}
                                <div class="mt-5 pt-5 d-flex flex-column align-items-center justify-content-center">
                                    <div style={{width:"fit-contet"}}>
                                    <p class="text-center mt-5 mb-5">¿Tienes alguna duda? ¡Escríbenos!</p>

                                            <Button
                                                to="/contact"
                                                content="CONTÁCTANOS"
                                                type="button-2 w-100"
                                            />
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* contact form section - end */}
        </>
    );
};

export default WaitingList;
